import { render, staticRenderFns } from "./ViewSection.vue?vue&type=template&id=8320ad72&scoped=true"
import script from "./ViewSection.vue?vue&type=script&lang=js"
export * from "./ViewSection.vue?vue&type=script&lang=js"
import style0 from "./ViewSection.vue?vue&type=style&index=0&id=8320ad72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8320ad72",
  null
  
)

export default component.exports